import React, { useState, useEffect } from 'react';
import {Menu} from "./Menu"
import { NavHeader } from './NavHeader';
//import { Link } from 'react-router-dom'

export function MenuBox ({items, Page, checkMenuChange}){  
  const [menuItems, setMenuItems] = useState(items) ;
  const [page, setPage] = useState(Page) ;

  if(menuItems !== items){
    setMenuItems(items);
  }
  if(page !== Page){
    setPage(Page)
  }

  var menu = "";
  //console.log(page)
  if(menuItems !== undefined && page !== undefined){
    //console.log(page.pageId)
    menu = <Menu key={"Menu"+page.pageId} items={menuItems}  Page={page} checkMenuChange={checkMenuChange} />  
  }

  return (
    <nav className="navbar-default navbar-static-side" role="navigation">
        <div className="sidebar-collapse">
            <ul className="nav metismenu" id="side-menu">
                <NavHeader />
                {menu}
                <li>
                   <h4 className="h4color">系統管理</h4>
                    
                </li>
                {/**
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">申請人</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">申請人列表</a></li>
                        <li><a href="form_advanced.html">申請人新增</a></li>
                        <li><a href="form_wizard.html">申請人編輯</a></li>
                        <li><a href="form_file_upload.html">申請人檢視</a></li>
                    </ul>
                </li>
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">帳號</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">帳號列表</a></li>
                        <li><a href="form_advanced.html">帳號新增</a></li>
                        <li><a href="form_wizard.html">帳號編輯</a></li>
                        <li><a href="form_file_upload.html">帳號檢視</a></li>
                    </ul>
                </li>   
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">勞動條件設定</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">勞動條件列表</a></li>
                        <li><a href="form_advanced.html">勞動條件新增</a></li>
                        <li><a href="form_wizard.html">勞動條件編輯</a></li>
                        <li><a href="form_file_upload.html">勞動條件檢視</a></li>
                    </ul>
                </li>
                
                <li>
                     <a href="grid_options.html"><i className="fa fa-laptop"></i> <span className="nav-label">公告發布</span></a>
                </li>
                
                <li>
                   <h4 className="h4color">基礎設定</h4>
                    
                </li>  
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label"> 公司管理</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">公司管理列表</a></li>
                        <li><a href="form_advanced.html">公司管理新增</a></li>
                        <li><a href="form_wizard.html">公司管理編輯</a></li>
                        <li><a href="form_file_upload.html">公司管理檢視</a></li>
                    </ul>
                </li>
                
                 <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">職務權限管理</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">部門列表</a></li>
                        <li><a href="form_advanced.html">部門新增</a></li>
                        <li><a href="form_wizard.html">部門編輯</a></li>
                        <li><a href="form_file_upload.html">部門檢視</a></li>
                    </ul>
                </li>  
                
                <li>
                     <a href="grid_options.html"><i className="fa fa-laptop"></i> <span className="nav-label">打卡管理</span></a>
                </li>
                
                 <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">休假/獎懲設定</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">休假/獎懲檢視</a></li>
                        <li><a href="form_file_upload.html">休假/獎懲檢視</a></li>
                    </ul>
                </li>
                
                 <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">薪資計算週期</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li><a href="form_file_upload.html">週期檢視</a></li>
                        <li><a href="form_wizard.html">週期編輯</a></li>
                    </ul>
                </li>
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">薪資考勤設定</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">薪資考勤設定</a></li>
                        <li><a href="form_wizard.html">薪資考勤編輯</a></li>
                        <li><a href="form_file_upload.html">薪資考勤檢視</a></li>
                    </ul>
                </li>
                <li>
                   <h4 className="h4color">應用表單設計</h4>
                    
                </li>  
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">薪資條</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li><a href="form_file_upload.html">薪資條檢視</a></li>
                        <li><a href="form_wizard.html">薪資條編輯</a></li>
                    </ul>
                </li>
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">請假單</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li><a href="form_file_upload.html">請假單檢視</a></li>
                        <li><a href="form_wizard.html">請假單編輯</a></li>
                    </ul>
                </li>        
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">聯絡單</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">聯絡單列表</a></li>
                        <li><a href="form_advanced.html">聯絡單新增</a></li>
                        <li><a href="form_wizard.html">聯絡單編輯</a></li>
                        <li><a href="form_file_upload.html">聯絡單檢視</a></li>
                    </ul>
                </li>
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">預支薪資</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li><a href="form_file_upload.html">預支薪資檢視</a></li>
                    </ul>
                </li>
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">員工履歷表</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li><a href="form_file_upload.html">員工履歷表檢視</a></li>
                        <li><a href="form_wizard.html">員工履歷表編輯</a></li>
                    </ul>
                </li>
                 
               <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">外派員工履歷表</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li><a href="form_file_upload.html">外派員工履歷表檢視</a></li>
                        <li><a href="form_wizard.html">外派員工履歷表編輯</a></li>
                    </ul>
                </li>
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">客戶資料</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li><a href="form_file_upload.html">客戶資料檢視</a></li>
                        <li><a href="form_wizard.html">客戶資料編輯</a></li>
                    </ul>
                </li>
                
                <li>
                   <h4 className="h4color">資料庫管理</h4>
                    
                </li>
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">員工管理</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">員工列表</a></li>
                        <li><a href="form_advanced.html">員工新增</a></li>
                        <li><a href="form_wizard.html">員工編輯</a></li>
                        <li><a href="form_file_upload.html">員工檢視</a></li>
                    </ul>
                </li>
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label">外派員工管理</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">外派員工列表</a></li>
                        <li><a href="form_advanced.html">外派員工新增</a></li>
                        <li><a href="form_wizard.html">外派員工編輯</a></li>
                        <li><a href="form_file_upload.html">外派員工檢視</a></li>
                    </ul>
                </li>
                
                <li>
                    <a href="#"><i className="fa fa-edit"></i> <span className="nav-label"> 客戶管理</span><span className="fa arrow"></span></a>
                    <ul className="nav nav-second-level">
                        <li className="active"><a href="form_basic.html">客戶管理列表</a></li>
                        <li><a href="form_advanced.html">客戶管理新增</a></li>
                        <li><a href="form_wizard.html">客戶管理編輯</a></li>
                        <li><a href="form_file_upload.html">客戶管理檢視</a></li>
                    </ul>
                </li>
                 */}
                
                  
        
            </ul>

        </div>
    </nav>
  )
}